<template>
    <!--START WEBSITE-DESCRIPTION-->
        <section class="section section-lg bg-web-desc">
            <div class="bg-overlay"></div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 text-center">
                        <h2 class="text-white">Build your dream website today</h2>
                        <p class="padding-t-15 home-desc">But nothing the copy said could convince her and so it didn’t take long until a few insidious Copy Writers ambushed her.</p>
                        <a href="#" class="btn btn-bg-white margin-t-30 waves-effect waves-light mb-5">View Plan & Pricing</a>
                    </div>
                </div>
            </div>
            <div class="bg-pattern-effect">
                <img src="images/bg-pattern.png" alt="">
            </div>
        </section>
        
        <!--END WEBSITE-DESCRIPTION-->
</template>

<script>
export default {
  name: 'WebConfiguration',
  props: {
  }
}
</script>